import { render, staticRenderFns } from "./UserWrapper.vue?vue&type=template&id=0bc0b2c2&scoped=true&"
import script from "./UserWrapper.vue?vue&type=script&lang=js&"
export * from "./UserWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UserWrapper.vue?vue&type=style&index=0&id=0bc0b2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0b2c2",
  null
  
)

export default component.exports